<div id="button">
  <button mat-button class="{{ buttonClass }}" [matMenuTriggerFor]="menu" (click)="menuOpened($event)"
  >
    <span class="label-primecap">{{label}}</span>
    <mat-icon>keyboard_arrow_down</mat-icon>
  </button>
  <mat-menu #menu="matMenu" backdropClass="engenharia-dropdown-button-menu">
    <ng-content select="button-menu-item"></ng-content>
  </mat-menu>
</div>